import { useActiveOrganization } from "@hooks/useActiveOrganization";
import { useOrganizationTasksListFiltersCache } from "@hooks/view/useTasksListFiltersCache";
import { useUserStatus } from "@hooks/useUserStatus";
import {
    ORGANIZATION_USER_CACHE_KEYS,
    useOrganizationUserCache,
} from "@hooks/useOrganizationUserCache";
import type { TasksLanding } from "@components/tasks/tasksLanding";
import { useMonthEndCloseViewParams } from "@components/tasks/views/useMonthEndCloseViewParams";
import { resolveOrganizationTasksLanding } from "./organizationTasksLanding";

export function useOrganizationTasksLanding(): TasksLanding | null {
    const activeOrganization = useActiveOrganization();
    const { data: userStatus } = useUserStatus();
    const [cachedFilters] = useOrganizationTasksListFiltersCache();
    const [cachedBaseViewId] = useOrganizationUserCache<string | null>(
        ORGANIZATION_USER_CACHE_KEYS.CLIENTS_TASKS_PAGE_BASE_VIEW_ID_CACHE_KEY,
    );
    const { isAwaitingFirstFetch } = useMonthEndCloseViewParams();
    const user = userStatus?.user;

    if (activeOrganization === null || user === undefined) {
        return null;
    }

    return resolveOrganizationTasksLanding({
        user,
        hasCachedState:
            cachedFilters !== undefined || cachedBaseViewId !== undefined,
        isAwaitingFirstFetch,
    });
}
